import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["tagName", "variant", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
var styles = {
  "root": "Help-root_1F4jj",
  "default": "Help-default_3OayV",
  "checkbox": "Help-checkbox_1h27Q",
  "radio": "Help-radio_CUuZD",
  "switch": "Help-switch_1SXFm"
};
function Help(_ref) {
  var _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'p' : _ref$tagName,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      tagName: tagName,
      color: "light",
      marginTop: "none",
      marginBottom: "none",
      className: clsx(styles.root, styles[variant], className)
    }, extraProps))
  );
}
export default Help;